import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://lws-server-assignment.herokuapp.com",
    }),
    tagTypes: ["todos"],
    endpoints: (builder) => ({
        getTodos: builder.query({
            query: (status) => {
                let queryString = "/todos";

                if (status === "Complete") {
                    queryString = "/todos?completed_like=true";
                    return queryString;
                } else if (status === "Incomplete") {
                    queryString = "/todos?completed_like=false";
                    return queryString;
                } else {
                    return queryString;
                }
            },
            providesTags: ["todos"],
        }),
        addTodo: builder.mutation({
            query: (data) => ({
                url: "/todos",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["todos"],
        }),
        removeTodo: builder.mutation({
            query: (id) => ({
                url: `/todos/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["todos"],
        }),
        changeTodoStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: {
                    completed: status,
                },
            }),
            invalidatesTags: ["todos"],
        }),
        changeTodoColor: builder.mutation({
            query: ({ id, color }) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: {
                    color: color,
                },
            }),
            invalidatesTags: ["todos"],
        }),
        markAllCompleted: builder.mutation({
            query: (id) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: {
                    completed: true,
                },
            }),
            invalidatesTags: ["todos"],
        }),
    }),
});

export const {
    useGetTodosQuery,
    useAddTodoMutation,
    useRemoveTodoMutation,
    useChangeTodoStatusMutation,
    useChangeTodoColorMutation,
    useMarkAllCompletedMutation,
} = apiSlice;
